"use client";

import {useTranslations} from "next-intl";

export function FaqSection() {
  const t = useTranslations("faq");

  return (
    <section
      id="faq"
      aria-labelledby="faq-heading"
      className="border-t border-[#173b35]/8 bg-[#efede6] px-4 py-16 dark:border-white/8 dark:bg-[#0d1d1b] sm:px-6 md:py-24 lg:px-8"
    >
      <div className="mx-auto max-w-3xl">
        <p className="clinic-eyebrow">
          {t("eyebrow")}
        </p>
        <h2
          id="faq-heading"
          className="clinic-display clinic-heading"
        >
          {t("title")}
        </h2>
        <div className="mt-8 space-y-3">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
            <details
              key={i}
              className="group rounded-2xl border border-[#173b35]/10 bg-[#fffefa] p-5 shadow-[0_10px_30px_-28px_rgba(23,59,53,0.5)] open:border-[#175e52]/25 open:shadow-md dark:border-white/10 dark:bg-[#17302c]"
            >
              <summary className="cursor-pointer list-none text-base font-semibold text-[var(--clinic-ink)] outline-none marker:content-none [&::-webkit-details-marker]:hidden">
                <span className="flex items-start justify-between gap-3">
                  <span>{t(`items.${i}.question`)}</span>
                  <span
                    className="mt-0.5 shrink-0 text-[#c95f4b] transition group-open:rotate-180"
                    aria-hidden
                  >
                    ▼
                  </span>
                </span>
              </summary>
              <p className="mt-3 text-sm leading-7 text-[var(--clinic-muted)]">{t(`items.${i}.answer`)}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
